import Link, { LinkProps } from '../../../app/shared/components/Link';
import Logo, { LogoProps } from '../Logo/Logo';
import css from './LogoLink.css';

type LogoLinkProps = Pick<LinkProps, 'href'> & Pick<LogoProps, 'size' | 'variant'>;

export default function LogoLink({ href, size, variant }: LogoLinkProps) {
  return (
    <Link className={css.root} href={href}>
      <Logo size={size} variant={variant} />
    </Link>
  );
}
